module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eac93f41670096e94b9ed9f719706a26.png";